import React from "react";
import { usePermission } from "@/hooks/usePermission";

interface PermissionGateProps {
	/** Required permission (user needs at least one if array). Dot format e.g. "sales.create" */
	permission: string | string[];
	children: React.ReactNode;
}

/**
 * Renders children only when the current user has the given permission.
 * Use to hide Create/View/Edit/Delete buttons by permission.
 */
export const PermissionGate: React.FC<PermissionGateProps> = ({ permission, children }) => {
	const allowed = usePermission(permission);
	if (!allowed) return null;
	return <>{children}</>;
};
